import Produto from "../models/produto";
import ProdutoFilter from "../models/produto-filter";
import { get } from "../utils/ApiUtil";

export const fetchProdutoByFilterAsync = async (filter: ProdutoFilter) => get<Array<Produto>>("Produto", filter)
export const fetchProdutoByIdAsync = async (id: string) => get<Produto>(`Produto/${id}`)
export const fetchProdutoByInternalCodeAsync = async (id: string) => get<Produto>(`Produto/internalCode/${id}`)
